import React, { useContext, useEffect, useState } from 'react';
import PageBodyWrapper from "root/PageBodyWrapper";
import { getDataFromResponse, getNamedCustomDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { useParams, useSearchParams } from "react-router-dom";
import { getSchoolsWithQuestionStatus } from "root/DataFunctions/ChartFns";
import TableRagSchoolDetailReport from "root/Tables/TableRagSchoolDetailReport";
import GlobalContext from "root/Contexts/GlobalContext";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";


const AdminRagSchoolDetailReport = ( props ) =>
{
    let { section_number, table_question_id } = useParams ();

    const [ searchParams, setSearchParams ] = useSearchParams ();

    const status = searchParams.get ( 'status' )

    const [ data, setData ] = useState ( { loading: true, data: [] } );

    const sessionContext = useContext ( GlobalContext );

    const survey_type = sessionContext.getCurrentSurveyType ();

    useEffect ( () =>
    {
        getData ();
    }, [] );

    const getData = () =>
    {
        getSchoolsWithQuestionStatus ( 'current', section_number, table_question_id, status, ( response ) =>
        {
            const returnData = getDataFromResponse ( response );

            const questionData = getNamedCustomDataFromResponse ( response, 'question' );

            setData ( { loading: false, data: returnData, question: questionData } )
        } )
    }

    const colorStatus = status === '1' ? 'Red' : 'Amber';

    const composeSectionRef = ( record ) =>
    {
        const hasRef = record.section_ref !== null;

        const refText = hasRef ? record.section_ref + '. ' : '';

        return refText;
    }

    const composeRef = (record) =>
    {
        const hasRef = record.section_ref !== null && record.question_ref !== null ;

        const refText = hasRef ? record.section_ref + '.' + record.question_ref + '. ' : '' ;

        return refText ;
    }

    const sectionName = () =>
    {
        const rec = data.question;

        return rec.table_section_name;
    }

    return data.loading === true ? <SpinnerDiv/> :
        <PageBodyWrapper title={ 'Schools assessing themselves ' + colorStatus + ' for ' + sectionName () }
                         backButton={ true }>
            <div className='manage-grid-rows'>
                <div className='dash-header'>
                    { 'Question ' + composeRef( data.question ) }
                </div>
                <div className='dash-style' style={ { padding: '15px' } }>
                    <TableRagSchoolDetailReport data={ data } survey_type={ survey_type }/>
                </div>
            </div>
        </PageBodyWrapper>
}

export default AdminRagSchoolDetailReport;
